import CommonStyles from 'shared/style/commonPageStyles'
import styled from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	InputWrapper: styled.div`
		height: 40px;
		display: flex;
		gap: 8px;

		& > input {
			width: 100%;
			${({theme}) => theme.font.extra_small};
			padding: 0 20px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
	ContainerContent: styled.div`
		display: flex;
		flex-direction: column;
		gap: 15px;
	`,
	ContainerStatusDiv: styled.div`
		display: flex;
		align-items: center;
		gap: 40px;
		
		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 20px;
		}
	`,
	ContainerUsedDiv: styled.div`
		display: flex;
		align-items: center;
		gap: 4px;

		& > h2 {
			${({theme}) => theme.font.extra_small};
			font-weight: 700;
		}

		& > p {
			${({theme}) => theme.font.extra_small};
		}
	`,
}

export default Style
